/*
 * Copyright (c) 2023. Bolmate B.V.
 */
import React from 'react';
import {ChangeFunction, IndexedObject} from '@dvrd/dvr-controls';
import {BolmateSelect} from "../../index";
import {COUNTRIES} from "../../../../util/countryUtil";


interface Props {
    onChange: ChangeFunction;
    value?: string;
    disabled?: boolean;
    className?: string;
    itemsPosition?: 'top' | 'bottom';
    itemsHeight?: number | string;
    labelAsValue?: boolean;
    label?: string;
    labelClassName?: string;
    active?: boolean;
    withAll?: boolean;
    excludeCountryCodes?: string[];
    itemContainerClassName?: string;
    canOpen?: () => boolean;
}

function getUsableCountries(countries: IndexedObject<string>, excludeCountryCodes?: string[]): IndexedObject<string> {
    if (!excludeCountryCodes?.length) return countries;
    const usableCountries: IndexedObject<string> = {};
    for (const countryCode of Object.keys(countries)) {
        if (!excludeCountryCodes.includes(countryCode)) usableCountries[countryCode] = countries[countryCode];
    }
    return usableCountries;
}

export default function CountryField(props: Props) {
    const {
        className, disabled, itemsPosition, onChange, value, labelAsValue, label, labelClassName, active, withAll,
        excludeCountryCodes, itemContainerClassName, canOpen, itemsHeight
    } = props;
    const usableCountries = getUsableCountries(COUNTRIES, excludeCountryCodes);
    const items = Object.keys(usableCountries).map((countryCode: string) => ({
        value: labelAsValue ? COUNTRIES[countryCode] : countryCode,
        label: COUNTRIES[countryCode]
    }));
    if (withAll) items.splice(0, 0, {label: 'Alle landen', value: ''});

    return (
        <BolmateSelect value={value ?? 'NL'} onChange={onChange} items={items} disabled={disabled} className={className}
                       label={label ?? 'Land *'} itemsPosition={itemsPosition} itemsHeight={itemsHeight ?? '20rem'}
                       labelClassName={labelClassName} active={active} itemContainerClassName={itemContainerClassName}
                       canOpen={canOpen}/>
    )
}
